import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=60355e6e&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=60355e6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-60355e6e"

export default script